import { render, staticRenderFns } from "./boardList.vue?vue&type=template&id=276879fc&"
import script from "./boardList.vue?vue&type=script&lang=js&"
export * from "./boardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports